import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { CompanyLicensingTabGzDataProvider } from '../dataProvider/CompanyLicensingTabGzDataProvider';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class CompanyLicensingTabDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, CompanyLicensingTabGzDataProvider);
  }
}
